import React from 'react';
import UserHistoryContainer from 'containers/user/UserHistoryContainer';

const UserHistorySubpage = () => {
  return <UserHistoryContainer />;
};

export default UserHistorySubpage;



// WEBPACK FOOTER //
// ./src/pages/user/UserHistorySubpage.js